<template>
  <div>
        <loading 
     :active.sync="loadingApplication" 
        :is-full-page="true"
        color="grey"
    ></loading>
    <v-toolbar flat color="white" v-if="applicationInfo">
        <v-chip
          color="green"
          class="white--text"
          v-if="applicationInfo.isResolved && applicationInfo.isApproved"
          >Approved</v-chip
        >
        <v-chip
          color="red"
          class="white--text"
          v-else-if="applicationInfo.isResolved && applicationInfo.leadRejected"
          >Denied</v-chip
        >
        <v-chip color="light-blue" class="white--text" v-else>Pending</v-chip>
      <v-spacer></v-spacer>
 <v-btn round   v-if="!applicationInfo.leadAccepted && !applicationInfo.leadRejected && !readOnly"
 class="white--text" @click="qualifyLead()" color="primary">Qualify Lead</v-btn>
    <v-btn @click="processToOrder()" round color="primary" class="white--text" v-else-if="applicationInfo.leadAccepted&&documents.filter(x=>!x.signed&&x.signatureRequired).length==0">Process to Order</v-btn>

      <v-btn v-if="!readOnly"
        round @click="rejected()"
        color="red"
        class="white--text"
        >Reject</v-btn
      >
     
    </v-toolbar>
    <v-divider></v-divider>
     <v-stepper v-model="stepperModel" class="elevation-0" alt-labels>
    <v-stepper-header>
      <v-stepper-step
        step="1"
        color="light-green" 
        complete
      >
        {{applicationInfo.type}}
      </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
          color="light-green"
          step="2"
          :complete="applicationInfo.leadAccepted"
        >
          Qualified
        </v-stepper-step>

        <v-divider></v-divider>

      <v-stepper-step
        color="light-green" 
        step="3"
      >
        Processing
      </v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step step="4"
      color="light-green" 
      >
        Order
      </v-stepper-step>     
    </v-stepper-header>
  </v-stepper>
    <v-card flat>

        <v-card-text style="margin: 0; padding: 0">
            <v-layout wrap>
                <v-flex xs12 sm8>
                    <v-layout justify-start wrap>
                        <v-flex xs12 md6 style="border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; border-bottom: 1px solid lightgrey;">
                            <v-list subheader>
                                <v-subheader style="background: #f0f0f0"> Order Summary</v-subheader>
                                <span v-if="applicationInfo.deniedReason" style="padding: 5px; margin: 5px;"><b style="left: 5">Reason for Denial:</b>
                                    <p style="padding: 5px; margin: 5px; color: red">{{ applicationInfo.deniedReason }}</p>
                                </span>
                                <v-list-tile>
                                    <v-list-tile-action>
                                        <v-icon>location_on</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="fontSize: 14px" v-if="applicationInfo.location">
                                            {{ applicationInfo.location.locationDescription }}
                                        </v-list-tile-title>
                                        <v-list-tile-title style="fontSize: 12px" v-else>
                                            {{ formattedAddress }}
                                        </v-list-tile-title>
                                        <v-list-tile-subtitle style="fontSize: 14px">
                                            <span class="grey--text font-weight-light" v-if="applicationInfo.locationId">{{
                applicationInfo.location.locationNetwork.name
              }}</span>
                                            <span class="grey--text font-weight-light" v-else-if="applicationInfo.locationNetwork">{{
                applicationInfo.locationNetwork.name
              }}</span>
                                            <v-chip style="height: 18px" class="white--text" color="green" v-if="applicationInfo.location&&applicationInfo.location.locationNetwork.networkStatus=='Live'">Live</v-chip>
                                            <v-chip style="height: 18px" class="white--text" color="blue" v-if="applicationInfo.location&&applicationInfo.location.locationNetwork.networkStatus=='In Progress'">In Progress</v-chip>
                                            <v-chip style="height: 18px" class="white--text" color="orange" v-if="applicationInfo.location&&applicationInfo.location.locationNetwork.networkStatus=='Planned'">Planned</v-chip>
                                        </v-list-tile-subtitle>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <div style="width: 100%" v-if="applicationInfo&&applicationInfo.coordinates">
<gmap-map :zoom="12" :options="{
                        disableDefaultUI: true
                    }" :center="
                      applicationInfo.coordinates &&
                      applicationInfo.coordinates != null
                        ? JSON.parse(applicationInfo.coordinates)
                        : {
                 lng: 18.427059,
                lat: -33.919473
            }
                    " ref="mapRef" style="width: 100%; height: 300px; margin-top: 10px">
                                        <gmap-marker v-if="applicationInfo.coordinates" :position="JSON.parse(applicationInfo.coordinates)"></gmap-marker>
                                    </gmap-map>
                                </div>
                                
                                <v-list-tile>
                                    <v-list-tile-action>
                                        <v-icon>event</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="fontSize: 14px">
                                            Date Submitted
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action style="fontSize: 14px">
                                        {{ formatDate(applicationInfo.createdAt) }}
                                    </v-list-tile-action>
                                </v-list-tile>

                                <v-list-tile>
                                    <v-list-tile-action>
                                        <v-icon>event</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="fontSize: 14px">
                                            Preferred Activation Date:
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action style="fontSize: 14px">
                                        {{ applicationInfo.activationDate }}
                                    </v-list-tile-action>
                                </v-list-tile>
                              

                               
                                <span v-if="applicationInfo.notes" style="padding: 5px; margin: 5px;"><b style="left: 5">Notes:</b>
                                    <p style="padding: 5px; margin: 5px">{{ applicationInfo.notes }}</p>
                                </span>
                            </v-list>
                        </v-flex>

                             <v-flex xs12 md6 style="border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; border-bottom: 1px solid lightgrey; ">
                            <!-- <h3>
                        <v-icon v-if="!applicationInfo.isResolved && !applicationInfo.isContactVerified" color="orange">warning</v-icon>Contact Information
                    </h3> -->
                            <v-subheader style="background: #f0f0f0"> Contact Information</v-subheader>
                            <v-tabs grow v-model="showLocationContacts" v-if="locationContacts.length>0">
                                <v-tab>
                                    Order Contacts
                                </v-tab>
                                <v-tab>
                                    Existing Contacts <v-chip>{{locationContacts.length}}</v-chip>
                                </v-tab>
                            </v-tabs>
                            <v-list three-line v-if="showLocationContacts==0">
                                <v-list-tile>
                                    <v-list-tile-action>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-avatar size="32px" v-on="on" color="blue" class="white--text">1st</v-avatar>
                                            </template>
                                            <span>Primary Contact</span>
                                        </v-tooltip>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="fontSize: 14px">
                                            {{ applicationInfo.primaryContactTitle }}
                                            {{ applicationInfo.primaryContactFirstname }}
                                            {{ applicationInfo.primaryContactLastname }}
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title style="fontSize: 12px">
                                            <v-icon small color="grey">smartphone</v-icon> {{ applicationInfo.primaryContactMobileNumber }}
                                        </v-list-tile-sub-title>
                                        <v-list-tile-sub-title style="fontSize: 12px">
                                            <v-icon small color="grey">email</v-icon> {{ applicationInfo.primaryContactEmailAddress }}
                                        </v-list-tile-sub-title>
                                        <v-list-tile-sub-title style="fontSize: 12px">
                                            <v-icon small color="grey">email</v-icon> {{ applicationInfo.primaryContactEmailAddress }}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-layout justify-center wrap>
                                            <v-btn small icon class="ma-1" v-if="applicationInfo.primaryContactId === null&&!creatingPrimaryContact" round color="primary" @click="editContact('Primary')">
                                                <v-icon small>edit</v-icon>
                                            </v-btn>
                                            <v-btn small class="ma-1" v-if="
                                        !creatingPrimaryContact &&
                                          applicationInfo.primaryContactId === null &&
                                          !linkedPrimaryContacts.length > 0
                                      " round icon color="primary" @click="addContact('Primary')">
                                                <v-icon small>person_add</v-icon>
                                            </v-btn>
                                            <v-progress-circular v-if="creatingPrimaryContact" size="20" indeterminate color="primary"></v-progress-circular>
                                            <v-btn small v-if="
                                        applicationInfo.primaryContactId === null && linkedPrimaryContacts.length > 0
                                      " icon class="white--text ma-1" round color="orange" @click="similarContactsModalPrimary = true">
                                                <v-icon small color="white">priority_high</v-icon>
                                            </v-btn>
                                            <v-icon v-if="applicationInfo.primaryContactId !== null" color="green">check_circle_outline</v-icon>
                                        </v-layout>
                                    </v-list-tile-action>
                                </v-list-tile>

                                <v-list-tile v-if="applicationInfo.secondaryContactFirstname !== null">
                                    <v-list-tile-action>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-avatar size="32px" v-on="on" color="blue" class="white--text">2nd</v-avatar>
                                            </template>
                                            <span>Secondary Contact</span>
                                        </v-tooltip>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="fontSize: 14px">
                                            {{ applicationInfo.secondaryContactTitle }}
                                            {{ applicationInfo.secondaryContactFirstname }}
                                            {{ applicationInfo.secondaryContactLastname }}
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title style="fontSize: 12px">
                                            <v-icon small color="grey">smartphone</v-icon> {{ applicationInfo.secondaryContactMobileNumber }}
                                        </v-list-tile-sub-title>
                                        <v-list-tile-sub-title style="fontSize: 12px">
                                            <v-icon small color="grey">email</v-icon> {{ applicationInfo.secondaryContactEmailAddress }}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-layout wrap justify-center>
                                            <v-btn small class="ma-1" v-if="applicationInfo.secondaryContactId === null&&!creatingSecondaryContact" round icon color="primary" @click="editContact('Secondary')">
                                                <v-icon small>edit</v-icon>
                                            </v-btn>
                                            <v-btn small class="ma-1" v-if="
                                        !creatingSecondaryContact &&
                                          applicationInfo.secondaryContactId === null &&
                                          !linkedSecondaryContacts.length > 0
                                      " round icon color="primary" @click="addContact('Secondary')">
                                                <v-icon small>person_add</v-icon>
                                            </v-btn>
                                            <v-progress-circular v-if="creatingSecondaryContact" size="20" indeterminate color="primary"></v-progress-circular>
                                            <v-btn small v-if="
                                        applicationInfo.secondaryContactId === null &&
                                          linkedSecondaryContacts.length > 0
                                      " class="white--text ma-1" round color="orange" @click="similarContactsModalSecondary = true" icon>
                                                <v-icon small color="white">priority_high</v-icon>
                                            </v-btn>
                                            <v-icon v-if="applicationInfo.secondaryContactId !== null" color="green">check_circle_outline</v-icon>
                                        </v-layout>
                                    </v-list-tile-action>
                                </v-list-tile>

                                <v-list-tile v-if="applicationInfo.billingContactFirstname !== null">
                                    <v-list-tile-action>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-avatar size="32px" v-on="on" color="blue">
                                                    <v-icon color="white">attach_money</v-icon>
                                                </v-avatar>
                                            </template>
                                            <span>Billing Contact</span>
                                        </v-tooltip>
                                    </v-list-tile-action>

                                    <v-list-tile-content>
                                        <v-list-tile-title style="fontSize: 14px">
                                            {{ applicationInfo.billingContactTitle }}
                                            {{ applicationInfo.billingContactFirstname }}
                                            {{ applicationInfo.billingContactLastname }}
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title style="fontSize: 12px">
                                            <v-icon small color="grey">smartphone</v-icon> {{ applicationInfo.billingContactMobileNumber }}
                                        </v-list-tile-sub-title>
                                        <v-list-tile-sub-title style="fontSize: 12px">
                                            <v-icon small color="grey">email</v-icon> {{ applicationInfo.billingContactEmailAddress }}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-layout row wrap justify-center>
                                            <v-btn class="ma-1" small v-if="applicationInfo.billingContactId === null&&!creatingBillingContact" round icon color="primary" @click="editContact('Billing')">
                                                <v-icon small>edit</v-icon>
                                            </v-btn>
                                            <v-btn small class="ma-1" v-if="
                                        !creatingBillingContact &&
                                          applicationInfo.billingContactId === null &&
                                          !linkedBillingContacts.length > 0
                                      " round icon color="primary" @click="addContact('Billing')">
                                                <v-icon small>person_add</v-icon>
                                            </v-btn>
                                            <v-progress-circular v-if="creatingBillingContact" size="20" indeterminate color="primary"></v-progress-circular>
                                            <v-btn small v-if="
                                        applicationInfo.billingContactId === null && linkedBillingContacts.length > 0
                                      " class="white--text ma-1" round color="orange" @click="similarContactsModalBilling = true" icon>
                                                <v-icon small color="white">priority_high</v-icon>
                                            </v-btn>
                                            <v-icon v-if="applicationInfo.billingContactId !== null" color="green">check_circle_outline</v-icon>
                                        </v-layout>
                                    </v-list-tile-action>
                                </v-list-tile>
                            </v-list>

                            <v-list v-else three-line>
                                <v-list-tile v-for="contact in locationContacts" :key="contact.id">
                                    <v-list-tile-content>
                                        <v-list-tile-title style="fontSize: 14px">
                                            {{ contact.contact.name }}
                                            {{ contact.contact.surname }}
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title style="fontSize: 14px">
                                            {{contact.contactType.name}} Contact | Created {{ formatDate(contact.createdAt)}}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-btn icon small color="red" @click="removeContact(contact)">
                                            <v-icon small color="white">delete</v-icon>
                                        </v-btn>
                                    </v-list-tile-action>
                                </v-list-tile>
                            </v-list>

                        </v-flex>

                    </v-layout>
                </v-flex>
                 <v-flex xs12 sm4>
                    <v-subheader style="background: #f0f0f0">Comments</v-subheader>
                    <v-layout align-center justify-center wrap class="ma-2">
                        <v-flex xs9>

                            <at-ta :members="members">
                                <v-textarea class="my-0 py-0" auto-grow rows="1" outline row-height="10" v-model="comment"></v-textarea>
                            </at-ta>
                        </v-flex>
                        <v-flex xs3 class="text-xs-left pl-3">
                            <v-btn class="ma-0 pa-0" icon @click="addApplicationComment(comment)">
                                <v-icon>send</v-icon>
                            </v-btn>
                            <v-checkbox class="ma-0 pa-0" label="Internal" v-model="internal"></v-checkbox>
                        </v-flex>
                    </v-layout>
                    <div style="overflow-y: auto; max-height: 50vh;">
                        <v-layout v-for="item in commentArray" :key="item.id" justify-start align-center style="border-bottom: 1px solid lightgrey">
                            <v-flex xs3 class="text-xs-left ml-1">
                                <b>{{ item.commentedByName
                            }} {{ item.commentedBySurname}}</b> <br>
                                <small>{{item.organisation.name}}</small> <br />
                                <v-chip style="height: 20px" outline v-if="item.isInternal" color="blue">Internal
                                </v-chip> <br v-if="item.isInternal" />
                                <span style="color: grey; font-size: 10px">{{ formatDateTime(item.createdAt) }}</span>
                            </v-flex>
                            <v-flex class="text-xs-left pa-2" xs8>

                                <span class="darkgrey--text text-xs-left" v-html="item.comment"></span>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-flex>
            </v-layout>
        </v-card-text>
    </v-card>

   

    <!-- Similar Contacts Modal -->
    <v-dialog v-model="similarContactsModalPrimary" max-width="750px">
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="headline white--text">SIMILAR CONTACTS</h3>
          <v-spacer></v-spacer>
          <!-- <v-btn @click="addContact('Primary')" class='white--text' flat><v-icon class='white--text' >add</v-icon> Create New Contact</v-btn> -->
        </v-toolbar>
        <v-card-text>
          <v-flex
            xs12
            sm6
            md6
            lg6
            v-for="person in linkedPrimaryContacts"
            :key="person.name"
          >
            <v-card hover class="text-xs-center mb-2 mx-2">
              <div class="subheading text-uppercase">
                {{ person.name }} {{ person.surname }}
              </div>
              <v-responsive></v-responsive>
              <v-card-text>
                <v-layout>
                  <v-flex xs2 class="text-xs-right">
                    <v-icon small color="grey">smartphone</v-icon>
                  </v-flex>
                  <v-flex xs8 justify-left>
                    <div class="grey--text">{{ person.mobileNumber }}</div>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs2 class="text-xs-right">
                    <v-icon small color="grey">email</v-icon>
                  </v-flex>
                  <v-flex xs8 justify-left>
                    <div class="grey--text">{{ person.emailAddress }}</div>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs2 class="text-xs-right">
                    <v-icon small color="grey">perm_identity</v-icon>
                  </v-flex>
                  <v-flex xs8 justify-left>
                    <div class="grey--text">{{ person.idNumber }}</div>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions class="justify-center layout px-0">
                <v-btn
                  color="light-blue white--text"
                  round
                  @click="mergePrimaryContact(person)"
                >
                  <v-icon small>call_merge</v-icon>Merge
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn
              round
              color="primary"
              @click="similarContactsModalPrimary = false"
              >Cancel</v-btn
            >
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="attachLocationModal" max-width="800px">
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="headline white--text">Attach Location</h3>
          <v-spacer></v-spacer>
           <v-btn flat color="white" @click="attachLocationModal=false">X</v-btn>
        </v-toolbar>
        <v-card-text>
          <v-checkbox
            label="Attach existing location"
            v-model="attachExistingLocation"
          ></v-checkbox>
          <v-layout v-if="attachExistingLocation">
            <v-spacer></v-spacer>
            <v-flex xs6 mx-2>
              <v-text-field
                label="Search"
                v-model="search"
                clearable
                append-icon="search"
                v-on:keyup.enter="
                  $router.push({
                    name: $route.name,
                    query: {
                      offset: $route.query.offset,
                      records: $route.query.records,
                      search: search,
                    },
                  })
                "
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout justify-center v-if="attachExistingLocation">
            <v-data-table
              :items="filteredLocations"
              :headers="locationHeaders"
              hide-actions
            >
              <template v-slot:items="props">
                <td class="text-xs-center">
                  <v-icon @click="attachExisting(props.item.id)" color="primary"
                    >add_circle_outline</v-icon
                  >
                </td>
                <td class="text-xs-center">{{ props.item.unitNo }}</td>
                <td class="text-xs-center">{{ props.item.erfNo }}</td>
                <td class="text-xs-center">{{ props.item.otherNo }}</td>
                <td class="text-xs-center">
                  {{ props.item.complexStreetName }}
                </td>
                <td
                  class="text-xs-center"
                  v-if="props.item.locationNetworkSubComplexId !== null"
                >
                  {{ props.item.locationNetworkSubComplex.subcomplexName }}
                </td>
                <td v-else></td>
                <td class="text-xs-center">
                  {{ props.item.locationNetwork.name }}
                </td>
              </template>
            </v-data-table>
          </v-layout>
          <v-layout v-if="attachExistingLocation" justify-center>
            <div class="text-xs-center pt-2 white" :key="$route.query.offset">
              <v-pagination
                v-model="page"
                :length="Math.ceil(locationLength / $route.query.records)"
                :total-visible="7"
              ></v-pagination>
            </div>
          </v-layout>
          <v-container v-if="!attachExistingLocation" grid-list-xs>
            <v-layout wrap>
              <v-flex xs12 sm6 md4>
                <v-autocomplete
                  clearable
                  hide-no-data
                  flat
                  color="primary"
                  :items="locationNetworks"
                  item-text="name"
                  item-value="id"
                  label="*Select an associated Network"
                  v-model="applicationInfo.locationNetworkId"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-autocomplete
                  clearable
                  hide-no-data
                  flat
                  color="primary"
                  :items="subComplexes"
                  item-text="subComplexName"
                  item-value="id"
                  label="Select an associated Sub Complex"
                  v-model="applicationInfo.locationNetworkSubComplexId"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-autocomplete
                  clearable
                  hide-no-data
                  flat
                  color="primary"
                  :items="locationTypes"
                  item-text="name"
                  item-value="id"
                  v-model="applicationInfo.locationTypeId"
                  label="*Location Type"
                  persistent-hint
                >
                </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="applicationInfo.erfNo"
                  label="Erf No"
                  type="number"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="applicationInfo.streetNumber"
                  label="*Unit No"
                  required
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="applicationInfo.otherNo"
                  label="Other No"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="applicationInfo.floorNo"
                  label="Floor No"
                  type="number"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="applicationInfo.streetName"
                  label="Complex Street Name"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="applicationInfo.complexName"
                  label="Complex Name"
                  required
                  persistent-hint
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          <v-layout justify-center v-if="!attachExistingLocation">
            <v-btn round color="primary" v-if="applicationInfo.locationTypeId" @click="createNewLocation()"
              >Create New Location</v-btn
            >
             <v-btn round color="primary" v-else disabled
              >Create New Location</v-btn
            >
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Similar Contacts Modal -->
    <v-dialog v-model="similarContactsModalSecondary" max-width="750px">
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="headline white--text">SIMILAR CONTACTS</h3>
          <v-spacer></v-spacer>
          <!-- <v-btn @click="addContact('Primary')" class='white--text' flat><v-icon class='white--text' >add</v-icon> Create New Contact</v-btn> -->
        </v-toolbar>
        <v-card-text>
          <v-flex
            xs12
            sm6
            md6
            lg6
            v-for="person in linkedSecondaryContacts"
            :key="person.name"
          >
            <v-card hover class="text-xs-center mb-2 mx-2">
              <div class="subheading text-uppercase">
                {{ person.name }} {{ person.surname }}
              </div>
              <v-responsive></v-responsive>
              <v-card-text>
                <v-layout>
                  <v-flex xs2 class="text-xs-right">
                    <v-icon small color="grey">smartphone</v-icon>
                  </v-flex>
                  <v-flex xs8 justify-left>
                    <div class="grey--text">{{ person.mobileNumber }}</div>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs2 class="text-xs-right">
                    <v-icon small color="grey">email</v-icon>
                  </v-flex>
                  <v-flex xs8 justify-left>
                    <div class="grey--text">{{ person.emailAddress }}</div>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs2 class="text-xs-right">
                    <v-icon small color="grey">perm_identity</v-icon>
                  </v-flex>
                  <v-flex xs8 justify-left>
                    <div class="grey--text">{{ person.idNumber }}</div>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions class="justify-center layout px-0">
                <v-btn
                  color="light-blue white--text"
                  round
                  @click="mergeSecondaryContact(person)"
                >
                  <v-icon small>call_merge</v-icon>Merge
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn
              round
              color="primary"
              @click="similarContactsModalSecondary = false"
              >Cancel</v-btn
            >
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Similar Contacts Modal -->
    <v-dialog v-model="similarContactsModalBilling" max-width="750px">
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="headline white--text">SIMILAR CONTACTS</h3>
          <v-spacer></v-spacer>
          <!-- <v-btn @click="addContact('Primary')" class='white--text' flat><v-icon class='white--text' >add</v-icon> Create New Contact</v-btn> -->
        </v-toolbar>
        <v-card-text>
          <v-flex
            xs12
            sm6
            md6
            lg6
            v-for="person in linkedBillingContacts"
            :key="person.name"
          >
            <v-card hover class="text-xs-center mb-2 mx-2">
              <div class="subheading text-uppercase">
                {{ person.name }} {{ person.surname }}
              </div>
              <v-responsive></v-responsive>
              <v-card-text>
                <v-layout>
                  <v-flex xs2 class="text-xs-right">
                    <v-icon small color="grey">smartphone</v-icon>
                  </v-flex>
                  <v-flex xs8 justify-left>
                    <div class="grey--text">{{ person.mobileNumber }}</div>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs2 class="text-xs-right">
                    <v-icon small color="grey">email</v-icon>
                  </v-flex>
                  <v-flex xs8 justify-left>
                    <div class="grey--text">{{ person.emailAddress }}</div>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs2 class="text-xs-right">
                    <v-icon small color="grey">perm_identity</v-icon>
                  </v-flex>
                  <v-flex xs8 justify-left>
                    <div class="grey--text">{{ person.idNumber }}</div>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions class="justify-center layout px-0">
                <v-btn
                  color="light-blue white--text"
                  round
                  @click="mergeBillingContact(person)"
                >
                  <v-icon small>call_merge</v-icon>Merge
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn
              round
              color="primary"
              @click="similarContactsModalBilling = false"
              >Cancel</v-btn
            >
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Edit Contact -->
    <v-dialog persistent v-model="editContactModal" max-width="750px">
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="headline white--text">EDIT CONTACT</h3>
        </v-toolbar>
        <v-card-text>
          <v-text-field
            v-model="editedContact.name"
            label="Name"
          ></v-text-field>
          <v-text-field
            v-model="editedContact.surname"
            label="Surname"
          ></v-text-field>
          <v-text-field
            v-model="editedContact.idNumber"
            label="ID Number"
          ></v-text-field>
          <v-text-field
            v-model="editedContact.emailAddress"
            label="Email Address"
          ></v-text-field>
          <v-text-field
            v-model="editedContact.mobileNumber"
            label="Mobile Number"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn
              round
              color="primary"
              @click="(editContactModal = false), (editedContact = {})"
              >Cancel</v-btn
            >
            <v-btn round color="primary" @click="saveEditedContact">Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    

    <!-- Invoice Number Modal -->
    <v-dialog v-model="invoiceNumberDialog" max-width="750px">
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="headline white--text">INVOICE NUMBER</h3>
        </v-toolbar>
        <v-card-text>
          <v-text-field
            v-model="applicationInfo.invoiceNumber"
            label="Invoice Number"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn
              round
              color="primary"
              @click="
                (invoiceNumberDialog = false),
                  (applicationInfo.invoiceNumber = '')
              "
              >Cancel</v-btn
            >
            <v-btn round color="primary" @click="saveInvoiceStatus">Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Invoice Number Modal -->
    <v-dialog v-model="xeroContactsModal" max-width="750px">
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="headline white--text">SIMILAR CONTACTS IN XERO</h3>
        </v-toolbar>
        <v-flex
          class="mx-3 my-2"
          xs6
          v-for="contact in similarXeroContacts"
          :key="contact.ContactId"
        >
          <v-card mx-3 my-2 color="white">
            <v-layout row wrap align-center>
              <v-flex xs6>
                <h3 class="subheading grey--text">{{ contact.name }}</h3>
              </v-flex>
              <v-flex xs6>
                <h4 class="subheading grey--text">
                  Name Match: {{ contact.match }}%
                </h4>
              </v-flex>
              <v-flex xs6>
                <h4 class="subheading font-weight-light grey--text">
                  {{ contact.email }}
                </h4>
              </v-flex>
              <v-flex xs6>
                <v-btn round class="primary">
                  <v-icon color="white">add</v-icon>Invoice
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn round color="primary" @click="xeroContactsModal = false"
              >Cancel</v-btn
            >
            <v-btn round color="primary" @click="createXeroContact()"
              >Create New Xero Contact</v-btn
            >
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

   

    <v-dialog v-model="addCustomerModal" persistent width="800px">
      <v-card color="white" flat>
        <v-toolbar color="primary" flat>
          <h3 class="title white--text">ADD DATATILL CUSTOMER</h3>
          <v-spacer></v-spacer>
          <v-btn color="white" flat @click="addCustomerModal=false">X</v-btn>
        </v-toolbar>
        <v-card-text>
          <div v-if="existingDatatillCustomer">
            <v-layout justify-center align-center wrap>
               <h3 style="color:grey">Please select a customer from the existing DataTill customers found</h3>
               <v-flex xs4 mx-1 mt-2 v-for="found in foundExisting" :key="found.customerId">
                <div  name="packageCard" :id="found.customerId" class="elevation-5 ma-2 pa-2" style="text-align:center; padding:0px; cursor:pointer;"  :class= "{'greenBorder': (found.customerId==keepColorId)}" @click="selectExistingCustomer(found)" hover>
                    <div class="primary subheading text-uppercase white--text">{{found.type}}</div>
                    <v-responsive></v-responsive>
                    <v-card-text>
                      <div
                        class="subheading"
                      >{{found.fullName}}</div>
                    <v-layout v-if="found.mobile!==null">
                        <v-flex xs2 class="text-xs-right">
                          <v-icon small color="grey">smartphone</v-icon>
                        </v-flex>
                        <v-flex xs8 justify-left>
                          <div
                            class="grey--text"
                            style="text-overflow: ellipsis; overflow: hidden;"
                          >{{found.mobile}}</div>
                        </v-flex>
                      </v-layout>

                      <v-layout v-if="found.email!==null">
                        <v-flex xs2 class="text-xs-right">
                          <v-icon small color="grey">email</v-icon>
                        </v-flex>
                        <v-flex xs8 justify-left>
                          <div
                            class="grey--text"
                            style="text-overflow: ellipsis; overflow: hidden;"
                          >{{found.email}}</div>
                        </v-flex>
                      </v-layout>

                      <v-layout v-if="found.idNumber!==null">
                        <v-flex xs2 class="text-xs-right">
                          <v-icon small color="grey">perm_identity</v-icon>
                        </v-flex>
                        <v-flex xs8 justify-left>
                          <div
                            class="grey--text"
                            style="text-overflow: ellipsis; overflow: hidden;"
                          >{{found.idNumber}}</div>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  
                  </div>
            </v-flex>
          </v-layout>
           
          </div>
          <div v-else>
            <v-layout>
              <v-checkbox label="Create a new DataTill customer" v-model="createNewDatatillCustomer"
              ></v-checkbox> 
            </v-layout>
            <div v-if="createNewDatatillCustomer===true">
              <v-layout>
                <v-flex xs6 mx-3>
                  <v-autocomplete
                xs6
                :items="datatillContactTypeList"
                label="Select contact to add to DataTill"
                v-model="datatillContactType"
              ></v-autocomplete>
                </v-flex>
                <v-flex xs6 mx-3>
                <v-card hover class="text-xs-center mb-2 mx-2">
                    <div class="primary subheading text-uppercase white--text">{{datatillContactType}}</div>
                    <v-responsive></v-responsive>
                    <v-card-text>
                      <div
                        class="subheading"
                      >{{newCustomer.fullName}}</div>
                    <v-layout v-if="newCustomer.mobileNumber!==null">
                        <v-flex xs2 class="text-xs-right">
                          <v-icon small color="grey">smartphone</v-icon>
                        </v-flex>
                        <v-flex xs8 justify-left>
                          <div
                            class="grey--text"
                            style="text-overflow: ellipsis; overflow: hidden;"
                          >{{newCustomer.mobileNumber}}</div>
                        </v-flex>
                      </v-layout>

                      <v-layout v-if="newCustomer.emailAddress!==null">
                        <v-flex xs2 class="text-xs-right">
                          <v-icon small color="grey">email</v-icon>
                        </v-flex>
                        <v-flex xs8 justify-left>
                          <div
                            class="grey--text"
                            style="text-overflow: ellipsis; overflow: hidden;"
                          >{{newCustomer.emailAddress}}</div>
                        </v-flex>
                      </v-layout>

                      <v-layout v-if="newCustomer.idNumber!==null">
                        <v-flex xs2 class="text-xs-right">
                          <v-icon small color="grey">perm_identity</v-icon>
                        </v-flex>
                        <v-flex xs8 justify-left>
                          <div
                            class="grey--text"
                            style="text-overflow: ellipsis; overflow: hidden;"
                          >{{newCustomer.idNumber}}</div>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  
                  </v-card>
              </v-flex>
              </v-layout>
                  </div>
                  <div v-else>
                    <h3 style="color:grey">Please select a customer from the existing DataTill customers found</h3>
                  <v-layout wrap>
                    <v-spacer></v-spacer>
                        <v-text-field v-model="search2"
                                      append-icon="search"
                                      label="Search"
                                      single-line
                                      hide-details
                                      class="pa-3"
                                      clearable></v-text-field>
                    </v-layout>
                    <v-data-table v-model="selected"
                    :rows-per-page-items="[10, 25, 50, 100]"
                                  :headers="customerSearchHeaders"
                                  :items="allCustomers"
                                  :pagination.sync="pagination"
                                  :search="search2"
                                  item-key="id"
                                  class="elevation-1">

                        <template v-slot:items="props">
                            <tr :active="props.selected" @click="props.selected = !props.selected">
                                <td>
                                                <v-checkbox :input-value="props.selected"
                                                primary
                                                @click="selected=[]"
                                                hide-details></v-checkbox>
                                </td>

          <td class="text-xs-center" >{{props.item.accounting_code}}</td>
          <td class="text-xs-center" >{{props.item.contact_name}}</td>
          <td class="text-xs-center" >{{props.item.contact_email}}</td>
          <td class="text-xs-center" >{{props.item.contact_mobile}}</td>
                            </tr>
                        </template>
                    </v-data-table>
                  </div>
          </div>
          
        </v-card-text>
        <v-card-actions>
          <v-layout >
            <v-spacer></v-spacer>
            <v-btn round color="primary" class="white--text" 
            v-if="!existingDatatillCustomer&&createNewDatatillCustomer&&datatillContactType"
            @click="addCustomerModal=false;ispVerifyModal()"
            >NEXT</v-btn>
             <v-btn round color="primary" class="white--text" 
            v-else-if="!existingDatatillCustomer&&!createNewDatatillCustomer&&applicationInfo.datatillCustomerId!==null"
            @click="addCustomerModal=false;ispVerifyModal()"
            >NEXT</v-btn>
              <v-btn round color="primary" class="white--text" 
            v-else-if="existingDatatillCustomer&&selectedExistingCustomer"
            @click="addCustomerModal=false;ispVerifyModal()"
            >NEXT</v-btn>
            <v-btn round color="primary" class="white--text" v-else disabled>NEXT</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="quoteModal" width="1000px">
       <sagequotemodal :accounts="accounts" :customer="applicationInfo.primaryContact" :quote="quoteItem"  
       :taxtypes="taxTypes"
       :type="'create'"
       @save="saveQuote($event)"
       @closeModal="quoteItem={}, quoteModal=false"></sagequotemodal>
    </v-dialog>
   


    

   
  </div>
</template>

<script>
import Api from "@/services/Api";
import dateformat from "dateformat";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import LineChart from "../components/LineChart";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import GmapCustomMarker from "vue2-gmap-custom-marker";
import DocumentCard from "@/components/SignDocumentCard.vue";
import SageQuoteModal from '@/components/SageQuoteModal.vue'
export default {
  components: {
    documentcomponent: DocumentCard,
    "gmap-custom-marker": GmapCustomMarker,
    VueCtkDateTimePicker: VueCtkDateTimePicker,
    linechart: LineChart,
    loading: Loading,
    sagequotemodal: SageQuoteModal
  },
  data() {
    return {
      accounts: [],
      agreementTemplates: [],
      center: { lng: -33.919473, lat: 18.427059 },
      ticketCarousalArray:[],
      ticketIndex:0,
      commentArray:[],
      taxTypes: [],
      readOnly:false,
      applicationContactIndex:0,
      bridgeTemplates: [],
      configurationSettings: {},
      configModal: false,
      datatillIntegration: false,
      datatillContactType: null,
      datatillContactTypeList: [],
      documents: [],
      allCustomers: [],
      addCustomerModal: false,
      createNewDatatillCustomer: true,
      existingDatatillCustomer: false,
      selected: [],
      newCustomer: {},
      foundExisting: [],
      index:0,
      pages:[],
      quoteModal: false,
      quoteItem: {
        Lines: []
      },
      stepperModel: null,
      initialAccessBuildFee:0,
      initialAccessBuildDocument: '',
      keyAdditionalAccessBuildDocument:0,
      ticketCategoryId: null,
      feasibilityTests: [],
      lineChartData: null,
      userRoles: [],
      locations: [],
      locationLength: 0,
      subComplexes: [],
      locationTypes: [],
      locationHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
        {
          text: "Unit No",
          align: "center",
          value: "unitNo",
        },
        {
          text: "Erf No",
          align: "center",
          value: "erfNo",
        },
        {
          text: "Other No",
          align: "center",
          value: "otherNo",
        },
        {
          text: "Street Name",
          align: "center",
          value: "complexStreetName",
        },
        {
          text: "Sub Complex",
          align: "center",
          value: "locationNetworkSubComplex.subcomplexName",
        },
        {
          text: "Network",
          align: "center",
          value: "locationNetwork.name",
        },
      ],
      keySearch: 0,
      locationSearch: "",
      filteredLocations: [],
      locationFilter: null,
      locationNetworks: [],
      attachExistingLocation: true,
      attachLocationModal: false,
      snackbar: false,
      text: "",
      editedContact: {},
      editContactModal: false,
      invoiceNumberDialog: false,
      loadingApplication: false,
      xeroContacts: [],
      similarXeroContacts: [],
      installation: {},
      today: this.formatDate(new Date()),
      addInstallationModal: false,
      deniedReasonModal: false,
      filteredUsers: [],
      applicationInfo: "",
      search: "",
      page: 1,
      allDevices: [],
      device: null,
      locationContacts: [],
      showApplicationContacts: true,
      showLocationContacts: false,
      linkedPrimaryContacts: [],
      linkedSecondaryContacts: [],
      deniedReason: "",
      linkedBillingContacts: [],
      similarContactsModalPrimary: false,
      similarContactsModalSecondary: false,
      similarContactsModalBilling: false,
      xeroContactsModal: false,
      billedXeroContactId: null,
      provisionTemplate: null,
      verifyingContact: false,
      verifyingInstallation: false,
      verifyingDevice: false,
      creatingPrimaryContact: false,
      creatingSecondaryContact: false,
      creatingBillingContact: false,

      tickets: [],
      addTicketModal: false,
      ticketItem: {},
      ticketCommentLog: [],
      ticketAssignedLog: [],
      deviceBridges: [],
      provisionWarningModal: false,
      ethPorts: [1, 2, 3, 4],
      changedPort: null,
      ticketKey: 0,
      dateTimeSelect: false,
      y: "top",
      devicesLength: 0,
      pagination: { totalItems: 0 },
      tabs: [
        { name: "applicationContacts", displayName: "Application Contacts" },
        { name: "locationContacts", displayName: "Location Contacts" },
      ],
      locationTypeList: [
        "End Location",
        "Location Network",
        "Location Node",
        "Switching Centre",
      ],
      locationType: "End Location",
      tributeOptions: { lookup: "name", values: this.users },
      addCommentBox: false,
      comment: "",
      statuses: ["Incomplete", "Pending", "In Progress", "Complete"],
      importanceOptions: ["Normal", "Not Critical", "Average", "Urgent"],
      ticketCategoryItems: [],
      selectableTicketCategoryItems: [],
      ticketCategories: [],
      ticketOptions: {
        importance: "Average",
        currentStatus: "Pending",
        description: "",
      },
      comment: "",
      internal: true,
      headers: [
        {
          text: "Action",
          align: "center",
        },
        {
          text: "System Name",
          align: "center",
          value: "systemName",
        },
        {
          text: "Location",
          align: "center",
          value: "location.locationDescription",
        },
        {
          text: "Network",
          align: "center",
          value: "locationNetwork.name",
        },
        {
          text: "Node",
          align: "center",
          value: "locationNode.name",
        },
        {
          text: "Switching Centre",
          align: "center",
          value: "switchingCentre.name",
        },
        {
          text: "Make",
          align: "center",
          value: "deviceMakeModel.deviceMake.name",
        },
        {
          text: "Type",
          align: "center",
          value: "deviceMakeModel.deviceType.name",
        },
        {
          text: "Model",
          align: "center",
          value: "deviceMakeModel.name",
        },
        {
          text: "IP Address",
          align: "center",
          value: "ipAddress",
        },
        {
          text: "Serial Number",
          align: "center",
          value: "serialNumber",
        },
        {
          text: "Pon Mac",
          align: "center",
          value: "ponMac",
        },
        {
          text: "Mac Address",
          align: "center",
          value: "macAddress",
        },
        {
          text: "Pon Numerical",
          align: "center",
          value: "ponNumerical",
        },
        {
          text: "Product Number",
          align: "center",
          value: "productNumber",
        },

        {
          text: "Upstream Device",
          align: "center",
          value: "upstreamDevice.deviceMakeModel.name",
        },
        {
          text: "PON Address",
          align: "center",
          value: "ponAddress",
        },
        {
          text: "PON ID",
          align: "center",
          value: "ponId",
        },
        {
          text: "Frame",
          align: "center",
          value: "frame",
        },
        {
          text: "Slot",
          align: "center",
          value: "slot",
        },
        {
          text: "Port",
          align: "center",
          value: "port",
        },
        {
          text: "Note",
          align: "center",
          value: "note",
        },
        {
          text: "Active",
          align: "center",
          value: "isActive",
        },
      ],
    };
  },
  async created() {
    this.$router.push({
      name: this.$route.name,
      query: { offset: "0", records: "10" },
    });
    this.initialize();
    this.fetchApplicationComments()
  },
  watch: {
    'ticketOptions.ticketCategoryId': {
      immediate: true,
      handler(value){
        if(value){
          this.selectableTicketCategoryItems = this.ticketCategoryItems.filter(x=>x.isActive&&!x.isDeleted&&x.ticketCategoryId == value)
        }
      }
    },
    '$vuetify.breakpoint.lgAndDown':{
       immediate: true,
      async handler(value) {
        console.log(value)
        if (value && value !== null) {
           this.ticketCarousalArray=this.tickets.slice(this.ticketIndex, this.ticketIndex+1)
        }else{
           this.ticketCarousalArray=this.tickets.slice(this.ticketIndex, this.ticketIndex+2)
        }
      }
    },
    selected(value){
      if(value&&value.length>0){
        this.applicationInfo.datatillCustomerId = value[0].id
      } else {
        this.applicationInfo.datatillCustomerId = null
      }
    },
    datatillContactType(value) {
      if(value==='Primary'){      
      this.newCustomer.fullName = this.applicationInfo.primaryContactFirstname + ' ' + this.applicationInfo.primaryContactLastname
      this.newCustomer.idNumber = this.applicationInfo.primaryContactIdNumber
      this.newCustomer.mobileNumber = this.applicationInfo.primaryContactMobileNumber
      this.newCustomer.telephoneNumber = this.applicationInfo.primaryContactMobileNumber
      this.newCustomer.emailAddress = this.applicationInfo.primaryContactEmailAddress
      }else if(value==='Secondary'){
      this.newCustomer.fullName = this.applicationInfo.secondaryContactFirstname + ' ' + this.applicationInfo.secondaryContactLastname
      this.newCustomer.idNumber = this.applicationInfo.secondaryContactIdNumber
      this.newCustomer.mobileNumber = this.applicationInfo.secondaryContactMobileNumber
      this.newCustomer.telephoneNumber = this.applicationInfo.secondaryContactMobileNumber
      this.newCustomer.emailAddress = this.applicationInfo.secondaryContactEmailAddress
      }else if(value==='Billing'){
      this.newCustomer.fullName = this.applicationInfo.billingContactFirstname + ' ' + this.applicationInfo.billingContactLastname
      this.newCustomer.idNumber = this.applicationInfo.billingContactIdNumber
      this.newCustomer.mobileNumber = this.applicationInfo.billingContactMobileNumber
      this.newCustomer.telephoneNumber = this.applicationInfo.billingContactMobileNumber
      this.newCustomer.emailAddress = this.applicationInfo.billingContactEmailAddress
      }
    },
    "ticketOptions.userRoleId": {
      immediate: true,
      async handler(value) {
        if (value && value !== null) {
          this.ticketOptions.assignedToId = null;
          Api()
            .get("/userRoleContact/byUserRole/" + value)
            .then((response) => {
              this.filteredUsers = response.data.map((x) => x.contact);
            });
        }
      },
    },
    filterUserRole: {
      immediate: true,
      async handler(value) {
        if (value && value !== null) {
          Api()
            .get("/userRoleContact/byUserRole/" + value)
            .then((response) => {
              this.filteredAssignedUsers = response.data.map((x) => x.contact);
            });
        } else {
          this.filteredAssignedUsers = this.filteredUsers;
        }
      },
    },
    users(value) {
      if (value.length > 0) {
        this.filteredUsers = this.users;
      }
    },
    "ticketOptions.assignedToId": {
      immediate: true,
      handler(value) {
        if (this.editTicketModal && value !== this.initialAssignedId) {
          if (
            this.ticketOptions.id &&
            value !== null &&
            typeof value !== "undefined"
          ) {
            Api()
              .post("/ticketAssignLog", {
                ticketId: this.ticketOptions.id,
                assignedToId: this.ticketOptions.assignedToId,
              })
              .then((response) => {
                let find = this.users.find((x) => x.id === value);
                response.data.assignedTo = find;
                response.data.assignedBy = this.$store.state.user;
                this.ticketAssignedLog.push(response.data);
              });
            Api().put("/ticket/" + this.ticketOptions.id, {
              assignedToId: this.ticketOptions.assignedToId,
            });
          }
        }
      },
    },
    "applicationInfo.locationNetworkId": {
      immediate: true,
      async handler(value) {
        if (value) {
          Api()
            .get("/locationNetworkSubcomplex/bynetwork/" + value)
            .then((response) => {
              this.subComplexes = response.data;
            });
        }
      },
    },
  
    locationFilter(value) {
      if (value !== null && typeof value !== "undefined") {

        this.filteredLocations = this.locations.filter(function (el) {
          return el.locationNetworkId === value;
        });
        this.locationLength = this.filteredLocations.length;
      } else {
        this.filteredLocations = this.locations;
        this.locationLength = this.filteredLocations.length;
      }
    },
    "$route.query.search": {
      immediate: true,
      handler(value) {
        if (this.$route.query.search && value !== "" && value != null) {
          Api()
            .get(
              "/Locations/byNetwork/" +
                this.applicationInfo.locationNetworkId +
                "/activeFilter",
              {
                params: {
                  search: value,
                  offset: "0",
                  records: this.$route.query.records,
                },
              }
            )
            .then((response) => {
              this.filteredLocations = response.data.result;
              this.locationLength = response.data.count;
            });
        } else if (this.$route.query.offset) {
          Api()
            .get(
              "/Locations/byNetwork/" +
                this.applicationInfo.locationNetworkId +
                "/activeFilter",
              {
                params: {
                  offset: this.$route.query.offset,
                  records: this.$route.query.records,
                },
              }
            )
            .then((response) => {
              this.filteredLocations = response.data.result;
              this.locationLength = response.data.count;
            });
        }
      },
    },
    "$route.query.offset": {
      immediate: true,
      handler(value) {
        this.loading = true;
        if (
          value !== "" &&
          value != null &&
          this.$route.query.search &&
          this.$route.query.search != "" &&
          this.$route.query.search !== null
        ) {
          Api()
            .get(
              "/Locations/byNetwork/" +
                this.applicationInfo.locationNetworkId +
                "/activeFilter",
              {
                params: {
                  search: this.$route.query.search,
                  offset: this.$route.query.offset,
                  records: this.$route.query.records,
                },
              }
            )
            .then((response) => {
              this.filteredLocations = response.data.result;
              this.locationLength = response.data.count;
            });
        } else if (value !== "" && value != null) {
          Api()
            .get(
              "/Locations/byNetwork/" +
                this.applicationInfo.locationNetworkId +
                "/activeFilter",
              {
                params: {
                  offset: this.$route.query.offset,
                  records: this.$route.query.records,
                },
              }
            )
            .then((response) => {
              this.filteredLocations = response.data.result;
              this.locationLength = response.data.count;
            });
        }
      },
    },
  },
  computed: {
formattedAddress(){
      let address = ''
      if(this.applicationInfo.unitNo){
        address += 'Unit '+this.applicationInfo.unitNo +', '
      }
      if(this.applicationInfo.floorNo){
        address += 'Floor '+this.applicationInfo.floorNo +', '
      }
      if(this.applicationInfo.building){
        address += this.applicationInfo.building +', '
      }
      if(this.applicationInfo.streetNumber){
        address += this.applicationInfo.streetNumber +' '
      }
      if(this.applicationInfo.streetName){
        address += this.applicationInfo.streetName +', '
      }
      if(this.applicationInfo.suburb){
        address += this.applicationInfo.suburb +', '
      }
      if(this.applicationInfo.town){
        address +=this.applicationInfo.town +', '
      }
      if(this.applicationInfo.province){
        address += this.applicationInfo.province +', '
      }
      if(this.applicationInfo.country){
        address += this.applicationInfo.country
      }
      if(this.applicationInfo.postalCode){
        address +=  ' ' + this.applicationInfo.postalCode
      }
      return address
    }
  },
  methods: {
    async addQuote(){
      if(this.authCreate(this.$store.state.currentRoute)){
        this.quoteItem = {Lines: []}
        this.quoteModal=true
      }
    },
    async saveQuote(data){
      console.log(data)
      data.applicationId = this.applicationInfo.id
      data.CustomerId = this.applicationInfo.accountingCustomerId
      data.TaxTypeId = data.TaxType?data.TaxType.ID:null
      data.AllowOnlineAccept = true
      data.contactId = this.applicationInfo.billingContactId?this.applicationInfo.billingContactId:this.applicationInfo.primaryContactId
      await Api().post('/sageOne/createQuote', data).then(res=>{
        this.quoteModal = false
        this.quoteItem = {}
      })
    },
    backTicketArrow(){
    this.ticketIndex--
    if(this.$vuetify.breakpoint.lgAndDown){
    this.ticketCarousalArray=this.tickets.slice(this.ticketIndex, this.ticketIndex+1)
    }else{
    this.ticketCarousalArray=this.tickets.slice(this.ticketIndex, this.ticketIndex+2)
    }

    this.ticketKey++   
    },
      fetchApplicationComments() {
            this.commentArray = [];
            Api()
                .get("/applicationComment/byApplication/" + this.$route.params.applicationId)
                .then(async (response) => {
                    this.commentArray = response.data.map((x) =>
                        ({
                            organisation: x.organisation,
                            commentedById: x.commentedById,
                            commentedByName: x.commentedBy.name,
                            commentedBySurname: x.commentedBy.surname,
                            comment: x.comment,
                            type: x.type,
                            createdAt: x.createdAt,
                            isInternal: x.isInternal,
                            id: x.id,
                            commentLogType: true,
                        })
                    )
                    this.commentArray.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                });
        },
     async addApplicationComment(comment) {
            // this.emailAddressArray = [];
            // this.mentioned = this.members.filter((x) => comment.includes(x));
            // await this.mentioned.map((y) => {
            //     this.membersEmail.map((x) => {
            //         if (x.fullName === y) {
            //             this.emailAddressArray.push(x.email);
            //         }
            //     });
            // });
            comment = comment.replace(/<div>/g, "");
            comment = comment.replace("</div>", "");
            comment = comment.replace(/<br>/g, "");
            Api()
                .post("/applicationComment", {
                    emailAddressArray: this.emailAddressArray,
                    isInternal: this.internal,
                    organisation: this.$store.state.currentOrg.org,
                    applicationId: parseInt(this.$route.params.applicationId),
                    type: "comment",
                    commentedById: this.$store.state.user.id,
                    comment: comment,
                })
                .then((response) => {
                    this.fetchApplicationComments();
                    this.comment = "";
                });
        },
    forwardTicketArrow(){
    this.ticketIndex++
    if(this.$vuetify.breakpoint.lgAndDown){
    this.ticketCarousalArray=this.tickets.slice(this.ticketIndex, this.ticketIndex+1)
    }else{
    this.ticketCarousalArray=this.tickets.slice(this.ticketIndex, this.ticketIndex+2)
    }

    this.ticketKey++   
    },
    saveAccessBuild() {
      Api()
        .put("/applications/" + this.applicationInfo.id, {
          additionalAccessBuildDocument: this.applicationInfo
            .additionalAccessBuildDocument,
          additionalAccessBuildFeeExclVat: this.applicationInfo
            .additionalAccessBuildFeeExclVat,
        })
        .then((response) => {
          this.getApplication();
        });
    },
    async selectFile(event) {
      await this.uploadFile(event.srcElement.files[0]);
    },
    async uploadFile(file) {
      var reader = await new FileReader();
      await reader.readAsDataURL(file);
      reader.onload = () => {
        this.setResult(reader.result);
      };
      reader.onerror = function () {
        console.log("there are some problems");
      };
    },
    setResult(result) {
      this.applicationInfo.additionalAccessBuildDocument = result;
      this.keyAdditionalAccessBuildDocument += 1;
    },
    async routeToTicketSummary(item) {
      if(!this.readOnly){
      let url = item;
      let route = await this.$store.state.currentOrg.org.permissions.filter(
        function (el) {
          return el.url === "/ticketSummary/:ticketId";
        }
      );
      await this.$store.dispatch("setCurrentRoute", route[0]);
      this.$router.push({ path: "/ticketSummary/" + item });
      }
    },
    addComment(comment) {
      this.ticketCommentLog.push({
        commentedBy: this.$store.state.user,
        commentedById: this.$store.state.user.id,
        comment: comment,
        type: "comment",
        createdAt: new Date(),
      });
      this.comment = "";
      this.addCommentBox = false;
    },
    removeContact(item) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        Api()
          .put("/LocationContact/" + item.id, {
            isDeleted: true,
            isActive: false,
          })
          .then((response) => {
            (item.isActive = false), (item.isDeleted = true);
          });
        let index = this.locationContacts.indexOf(item);
        this.locationContacts.splice(index, 1);
        if (!this.locationContacts.length > 0) {
          this.showApplicationContacts = true;
          this.showLocationContacts = false;
        }
      }
    },
    displayContents(name) {
      return this.activeTabName === name;
    },
    setActiveTabName(name) {
      this.activeTabName = name;
    },
    formatDateTime(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd HH:MM");
      } else {
        null;
      }
    },
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd");
      } else {
        null;
      }
    },
    processPortChange() {
      if (this.provisionTemplate != null) {
        if (this.changedPort) {
          this.provisionTemplate.tpIndex = this.changedPort;
        }
        let ponId = this.device.gponOnuId.toString();
        if (this.provisionTemplate.gponOnuId < 10) {
          ponId = "0" + ponId;
        }

        if (!this.provisionTemplate.autoSelectGemPortValue) {
          this.provisionTemplate.gponPortId =
            "3" + this.provisionTemplate.tpIndex.toString() + ponId;
        } else {
          this.provisionTemplate.gponPortId = 0;
        }
        this.changedPort = null;
        this.provisionWarningModal = false;
        this.approveApplication();
      }
    },
    prepareZhoneTemplate() {
      if (this.provisionTemplate != null) {
        this.provisionTemplate.Device_ID = this.device.Device_ID;
        this.provisionTemplate.Handle_ID = this.device.Handle_ID;
        this.provisionTemplate.gponSlotId = this.device.gponSlotId;
        this.provisionTemplate.gponOltId = this.device.gponOltId;
        this.provisionTemplate.gponPortId = this.device.gponPortId;

        this.provisionTemplate.gponOnuId = this.device.gponOnuId;
        if (this.changedPort) {
          this.provisionTemplate.tpIndex = this.changedPort;
        }
        let ponId = this.device.gponOnuId.toString();
        if (this.provisionTemplate.gponOnuId < 10) {
          ponId = "0" + ponId;
        }

        if (!this.provisionTemplate.autoSelectGemPortValue) {
          this.provisionTemplate.gponPortId =
            "3" + this.provisionTemplate.tpIndex.toString() + ponId;
        } else {
          this.provisionTemplate.gponPortId = 0;
        }
      }
    },
    filterByValue(array, string) {
      return array.filter((o) => {
        return Object.keys(o).some((k) => {
          if (typeof o[k] === "string")
            return o[k].toLowerCase().includes(string.toLowerCase());
        });
      });
    },
    async fetchXeroContacts() {
      await Api()
        .get("/xero/allContacts")
        .then((response) => {
          this.xeroContacts = response.data;
        });
    },
    async findSimilarContacts(contact, name, email) {
      let similarContacts = [];
      let similarNames = await this.filterByValue(this.xeroContacts, name);
      for (let a = 0; a < similarNames.length; a++) {
        let match =
          (await Math.round(
            this.similarity(name, similarNames[a].Name) * 10000
          )) / 100;
        await similarContacts.push({
          xeroContactId: similarNames[a].ContactID,
          match: match,
          name: similarNames[a].Name,
          email: similarNames[a].EmailAddress,
        });
      }
      this.similarXeroContacts = similarContacts;
      if (this.similarXeroContacts.length > 0) {
        this.xeroContactsModal = true;
      } else {
        this.xeroContactsModal = false;
        confirm(
          "Are you sure you would like to generate the invoice for " +
            contact.name +
            " " +
            contact.surname +
            "?"
        ) && this.generateXeroInvoice(contact);
      }
    },

    createXeroContact() {
      let contact = null;
      let taxNumber = null;
      if (this.applicationInfo.billingContactId !== null) {
        contact = this.applicationInfo.billingContact;
      } else if (this.applicationInfo.primaryContactId !== null) {
        contact = this.applicationInfo.primaryContact;
      }
      if (
        this.applicationInfo.billingContactId !== null &&
        this.applicationInfo.billingContactVatNumber !== null
      ) {
        taxNumber = null;
      } else {
        taxNumber = this.applicationInfo.billingContactVatNumber;
      }
      Api()
        .post("/xero/contact", {
          Name: contact.name + " " + contact.surname,
          FirstName: contact.name,
          LastName: contact.surname,
          EmailAddress: contact.emailAddress,
          ContactStatus: "ACTIVE",
          ContactID:
            this.makeContactId(8).toString() +
            "-" +
            this.makeContactId(4).toString() +
            "-" +
            this.makeContactId(4).toString() +
            "-" +
            this.makeContactId(4).toString() +
            "-" +
            this.makeContactId(8).toString(),
          //  00000000-0000-0000-0000-000000000000
          TaxNumber: this.applicationInfo.billingContactVatNumber,
          Addresses: [
            {
              AddressLine1: this.applicationInfo.location.locationDescription,
              AddressLine2: this.applicationInfo.location.locationNetwork
                .streetName,
              AddressLine3: this.applicationInfo.location.locationNetwork
                .suburb,
              AddressLine3: this.applicationInfo.location.locationNetwork.town,
              City: this.applicationInfo.location.locationNetwork.city,
              Country: this.applicationInfo.location.locationNetwork.country,
            },
          ],
        })
        .then((response) => {
          console.log(response.data);
        });
    },
    makeContactId(length) {
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
    similarity(s1, s2) {
      var longer = s1;
      var shorter = s2;
      if (s1.length < s2.length) {
        longer = s2;
        shorter = s1;
      }
      var longerLength = longer.length;
      if (longerLength == 0) {
        return 1.0;
      }
      return (
        (longerLength - this.editDistance(longer, shorter)) /
        parseFloat(longerLength)
      );
    },
    editDistance(s1, s2) {
      s1 = s1.toLowerCase();
      s2 = s2.toLowerCase();

      var costs = new Array();
      for (var i = 0; i <= s1.length; i++) {
        var lastValue = i;
        for (var j = 0; j <= s2.length; j++) {
          if (i == 0) costs[j] = j;
          else {
            if (j > 0) {
              var newValue = costs[j - 1];
              if (s1.charAt(i - 1) != s2.charAt(j - 1))
                newValue =
                  Math.min(Math.min(newValue, lastValue), costs[j]) + 1;
              costs[j - 1] = lastValue;
              lastValue = newValue;
            }
          }
        }
        if (i > 0) costs[s2.length] = lastValue;
      }
      return costs[s2.length];
    },
    fetchOrgContacts() {
      this.filteredUsers = [];
      Api()
        .get("/organisationContact")
        .then(async (response) => {
          this.filteredUsers = response.data
            .filter(function (el) {
              return el.userType !== "endClient";
            })
            .map((x) => x.contact);
        });
    },
    async initialize() {
        this.loadingApplication=true
      await this.getApplication();
      this.fetchLocationNetworks();
      this.fetchTickets();
      this.fetchOrgContacts();
      this.getlocationTypes();
      this.fetchUserRoles();
      this.fetchTicketCategories();
      this.fetchTicketCategoryItems();
      this.fetchFeasibilitytests()
      if(this.applicationInfo.packagesIsp&&this.applicationInfo.packagesIsp.datatillProductId &&this.applicationInfo.packagesIsp.customerOrganisationId == this.applicationInfo.supplierOrganisationId){
        this.checkDatatillIntegration()  
      }
      this.fetchDocuments()
      this.fetchAgreementTemplates()
      if(this.$store.state.currentOrg.org.accountingSystem == 'SageOne'){
        if(this.$store.state.currentOrg.org.accountBasedAccounting){
        this.fetchSageAccounts()
        } else {
          this.fetchSageItems()
        }
        this.fetchSageTaxTypes()
      }
      this.fetchCustomerQuotes()
      
    },
    async fetchCustomerQuotes(){
      let contactId = this.applicationInfo.billingContactId?this.applicationInfo.billingContactId:this.applicationInfo.primaryContactId
      Api().get('/customerBilling/contact/'+contactId).then(res=>{
        this.quotes = res.data
      })
    },
    async fetchSageTaxTypes(){
      await Api().get('/sageOne/taxTypes').then(res=>{
        this.taxTypes = res.data.Results
      })
    },
    async fetchSageAccounts(){
      await Api().get('/sageOne/accounts').then(res=>{
        let result = res.data.Results.filter(x=>x.Category.ID == 1)
        this.accounts = result.map(x=>({id: x.ID.toString(), name: x.Name}))
      })
    },
    async fetchSageItems(){
      await Api().get('/sageOne/items').then(res=>{
        this.accounts = result.map(x=>({id: x.ID.toString(), name: x.Name}))
      })
    },
    async goToLocation() {
      let route = await this.$store.state.currentOrg.org.permissions.filter(function(el) {
        return el.url === "/locationNetworks/:locationNetworkId/:locationId";
      });

      await this.$store.dispatch("setCurrentRoute", route[0]);
      this.$router.push({
        path:
          "/locationNetworks/" +
          this.applicationInfo.location.locationNetworkId +
          "/" +
          this.applicationInfo.locationId,
      });
    },
    fetchAgreementTemplates(){
      Api().get('/agreements/application/'+this.applicationInfo.id).then(res=>{
        this.agreementTemplates = res.data
      })
    },
    fetchDocuments() {
      Api()
        .get("/upload/byApplication/" + this.applicationInfo.id)
        .then((res) => {
          this.documents = res.data;
        });
    },
    async generateAgreements(){
      for(let i=0;i<this.agreementTemplates.length;i++){
        Api()
      .post('/upload',{
        name: this.agreementTemplates[i].name,
        isActive: true,
        isDeleted: false,
        locationId: this.applicationInfo.locationId,
        applicationId: this.applicationInfo.id,
        contactId: this.applicationInfo.primaryContactId,
        organisationAgreementId: this.agreementTemplates[i].id,
        signatureRequired: true,
        signed: false
      })
      }
    },
    qualifyLead(){
      Api().put('/applications/' + this.$route.params.applicationId,{
          leadAccepted: true
      }).then(async response=>{
        // this.applicationInfo.type='Qualified'
        this.applicationInfo.leadAccepted=true
        await this.generateAgreements()
        this.fetchDocuments()
      })
    },
    processToOrder(){
      Api().put('/applications/' + this.$route.params.applicationId,{
          type: 'Order'
      }).then(async response=>{
        this.$router.push({path: '/applications/'+this.applicationInfo.id})
      })
    },
    rejected(){
         Api().put('/applications/' + this.$route.params.applicationId,{
           isResolved: true,
           resolvedById: this.$store.state.user.id,
           leadRejected: true
         }).then(response=>{
           this.applicationInfo.isResolved=true
           this.applicationInfo.leadRejected=true
         })
    },
    checkDatatillIntegration(){
   Api().get('/integrations/byName/Datatill').then(response=>{
     if(response.data){
     this.datatillIntegration = true
     this.fetchDatatillCustomer()
     }
   })
    },
    fetchDatatillCustomer(){
      this.datatillContactType = 'Primary'
      this.datatillContactTypeList = []
      if(this.applicationInfo.primaryContactEmailAddress){
       this.datatillContactTypeList.push('Primary')
      }
      if(this.applicationInfo.secondaryContactEmailAddress){
       this.datatillContactTypeList.push('Secondary')
      }
      if(this.applicationInfo.billingContactEmailAddress){
       this.datatillContactTypeList.push('Billing')
      }
      Api()
        .post("/datatill/customerList",{
          organisationId: this.$store.state.currentOrg.org.id,
          primaryContactEmail: this.applicationInfo.primaryContactEmailAddress,
          secondaryContactEmail: this.applicationInfo.secondaryContactEmailAddress,
          billingContactEmail: this.applicationInfo.billingContactEmailAddress
          // contactEmail: 'cornelis.vanrensburg@gmail.com'
        })
        .then(response => { 
          this.allCustomers = response.data.allCustomers
          this.foundExisting = []
          if(response.data.primaryCustomerId!==null){    
            this.foundExisting.push({
              type: 'Primary',
              customerId: response.data.primaryCustomerId,
              fullName: this.applicationInfo.primaryContactFirstname + ' ' + this.applicationInfo.primaryContactLastname,
              email: this.applicationInfo.primaryContactEmailAddress,
              mobile: this.applicationInfo.primaryContactMobileNumber,
              idNumber: this.applicationInfo.primaryContactIdNumber
           })       
            // this.applicationInfo.datatillCustomerId = response.data.customerId
            // this.existingDatatillCustomer = true
          }
          if(response.data.secondaryCustomerId!==null){
            this.foundExisting.push({
              type: 'Secondary',
              customerId: response.data.secondaryCustomerId,
              fullName: this.applicationInfo.secondaryContactFirstname + ' ' + this.applicationInfo.secondaryContactLastname,
              email: this.applicationInfo.secondaryContactEmailAddress,
              mobile: this.applicationInfo.secondaryContactMobileNumber,
              idNumber: this.applicationInfo.secondaryContactIdNumber
           })  
            // this.existingDatatillCustomer = true
          }
           if(response.data.billingCustomerId!==null){
            this.foundExisting.push({
              type: 'Billing',
              customerId: response.data.billingCustomerId,
              fullName: this.applicationInfo.billingContactFirstname + ' ' + this.applicationInfo.billingContactLastname,
              email: this.applicationInfo.billingContactEmailAddress,
              mobile: this.applicationInfo.billingContactMobileNumber,
              idNumber: this.applicationInfo.billingContactIdNumber
            })  
            // this.existingDatatillCustomer = true
          }
         });
    },
    fetchFeasibilitytests(){
      // Api().get('/gis/feasibilityTest/application/'+this.$route.params.applicationId).then(async res=>{
      //   let center = this.applicationInfo.coordinates
      //   if(center){
      //     this.center = {lat: parseFloat(center.lat), lng: parseFloat(center.lng)}
      //   }
      //   this.feasibilityTests = res.data
      //   let findSuccess = this.feasibilityTests.find(x=>x.success)
      //   if(findSuccess){
      //   this.lineChartData = findSuccess
      //   }
      //    this.loadingApplication=false
      // })
       this.loadingApplication=false
    },
    getlocationTypes() {
      Api()
        .get("/locationTypes")
        .then((response) => {
          this.locationTypes = response.data;
        });
    },
    fetchUserRoles() {
      Api()
        .get("/userRole")
        .then((response) => {
          this.userRoles = response.data;
        });
    },

    fetchLocationNetworks() {
      Api()
        .get("/locationnetworks/basic/active")
        .then((response) => {
          this.locationNetworks = response.data;
        });
    },
    fetchTicketCategories() {
      Api()
        .get("/ticketCategory")
        .then((response) => {
          this.ticketCategories = response.data;
        });
    },
    fetchTicketCategoryItems() {
      Api()
        .get("/ticketCategoryItem")
        .then((response) => {
          this.ticketCategoryItems = response.data;
          this.ticketKey += 1;
        });
    },
    addCommentEditedTicket(comment) {
      Api()
        .post("/ticketComment", {
          ticketId: this.ticketItem.id,
          type: "comment",
          commentedById: this.$store.state.user.id,
          comment: comment,
        })
        .then((response) => {
          response.data.commentedBy = this.$store.state.user;
          this.ticketCommentLog.push(response.data);
          this.comment = "";
          this.addCommentBox = false;
        });
    },
    async fetchTickets() {
      await Api()
        .get("/ticket/byApplication/" + this.$route.params.applicationId)
        .then((response) => {
          this.tickets = response.data;
          let temp = response.data
          this.ticketCarousalArray = temp.slice(0,2)
          this.ticketKey += 1;
        });
    },
    attachExisting(id) {
      Api()
        .put("customer/applications/" + this.$route.params.applicationId, {
          locationId: id,
        })
        .then((response) => {
          this.attachLocationModal = false;
          this.getApplication();
          
        });
    },
    createNewLocation() {
      Api()
        .get("/locationNetworks/" + this.applicationInfo.locationNetworkId)
        .then((response) => {
          Api()
            .post("/locations", {
              locationDescription:
                this.applicationInfo.streetNumber +
                " " +
                this.applicationInfo.streetName +
                ", " +
                response.data.name,
              unitNo: this.applicationInfo.streetNumber,
              complexStreetName: this.applicationInfo.streetName,
              locationNetworkId: this.applicationInfo.locationNetworkId,

              locationTypeId: this.applicationInfo.locationTypeId,
              erfNo: this.applicationInfo.erfNo,
              otherNo: this.applicationInfo.otherNo,
              locationNetworkSubComplexId: this.applicationInfo
                .locationNetworkSubComplexId,
              floorNo: this.applicationInfo.floorNo,
              subComplexName: this.applicationInfo.subComplexName,
              complexName: this.applicationInfo.complexName,
              coordinates: this.applicationInfo.coordinates?JSON.stringify(this.applicationInfo.coordinates):null
            })
            .then((response) => {
              Api()
                .put(
                  "customer/applications/" + this.$route.params.applicationId,
                  {
                    locationId: response.data.id,
                  }
                )
                .then((response) => {
                  this.getApplication();
                  this.attachLocationModal = false;
                });
            });
        });
    },
    async generateXeroInvoice() {
      // await this.createXeroContact()
      let contact = null;
      let taxNumber = null;
      let lineItems = [];
      if (this.applicationInfo.billingContactId !== null) {
        contact = this.applicationInfo.billingContact;
      } else if (this.applicationInfo.primaryContactId !== null) {
        contact = this.applicationInfo.primaryContact;
      }
      if (this.applicationInfo.billingVatNumber !== null) {
        taxNumber = this.applicationInfo.billingVatNumber;
      }
      if (this.applicationInfo.routerInstallationFee > 0) {
        await lineItems.push({
          Description: "FTTH Installation Fee",
          AccountCode: "INS",
          Quantity: 1,
          UnitAmount: this.applicationInfo.routerInstallationFee,
        });
      }
      if (this.applicationInfo.gtuInstallationFee > 0) {
        await lineItems.push({
          Description: "GTU Installation Fee",
          AccountCode: "211",
          Quantity: 1,
          UnitAmount: this.applicationInfo.gtuInstallationFee,
        });
      }
      let date = new Date();
      Api()
        .post("/xero/invoice", {
          Type: "ACCREC",
          Contact: {
            Name: contact.name + " " + contact.surname,
            FirstName: contact.name,
            LastName: contact.surname,
            EmailAddress: contact.emailAddress,
            // EmailAddress: 'jarryd@dotparse.com',
            ContactStatus: "ACTIVE",
            TaxNumber: taxNumber,
            Addresses: [
              {
                AddressLine1: this.applicationInfo.location.locationDescription,
                AddressLine2: this.applicationInfo.location.locationNetwork
                  .streetName,
                AddressLine3: this.applicationInfo.location.locationNetwork
                  .suburb,
                AddressLine3: this.applicationInfo.location.locationNetwork
                  .town,
                City: this.applicationInfo.location.locationNetwork.city,
                Country: this.applicationInfo.location.locationNetwork.country,
              },
            ],
          },
          Reference: "FTTH Installation",
          Date: date,
          DueDate: date,
          LineAmountTypes: "Inclusive",
          LineItems: lineItems,
        })
        .then(async (response) => {
          if (response.status === 200) {
            this.snackbar = true;
            this.text = "Invoice successfully created!";
          }
          this.applicationInfo.invoiceNumber = response.data[0].invoiceNumber;
          this.applicationInfo.isInvoiced = true;
          await Api().put("/applications/" + this.applicationInfo.id, {
            isInvoiced: true,
            invoiceNumber: response.data[0].InvoiceNumber,
          });
          // await Api()
          // .post('/xero/emailInvoice',{
          //   InvoiceID: response.data[0].InvoiceID
          // }).then(response=>{
          //     this.snackbar=true
          //     this.text="Invoice successfully sent via email!"
          // })
          let transactionPost = [];
          if (this.applicationInfo.routerInstallationFee > 0) {
            await transactionPost.push({
              date: new Date(),
              description: "Router Installation",
              xeroCode: "1",
              amount: this.applicationInfo.routerInstallationFee / (1 + $VAT),
              isRecurring: false,
              transactionType: "Sales",
              locationId: this.applicationInfo.locationId,
              locationNetworkId: this.applicationInfo.location
                .locationNetworkId,
              locationNodeId: this.applicationInfo.location.locationNetwork
                .locationNodeId,
              isActive: true,
              isDeleted: false,
            });
          }
          if (
            this.applicationInfo.hasTvOverFibre &&
            this.applicationInfo.gtuInstallationFee > 0
          ) {
            await transactionPost.push({
              date: new Date(),
              description: "GTU Installation",
              xeroCode: "1",
              amount: this.applicationInfo.gtuInstallationFee / (1 + $VAT),
              isRecurring: false,
              transactionType: "Sales",
              locationId: this.applicationInfo.locationId,
              locationNetworkId: this.applicationInfo.location
                .locationNetworkId,
              locationNodeId: this.applicationInfo.location.locationNetwork
                .locationNodeId,
              isActive: true,
              isDeleted: false,
            });
          }
          await Api().post("/transactions/bulk", {
            batch: transactionPost,
          });
          this.initialize();
        });
    },
    editContact(contactType) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        if (contactType === "Primary") {
          this.editedContact.contactType = "Primary";
          this.editedContact.name = this.applicationInfo.primaryContactFirstname;
          this.editedContact.surname = this.applicationInfo.primaryContactLastname;
          this.editedContact.idNumber = this.applicationInfo.primaryContactIdNumber;
          this.editedContact.emailAddress = this.applicationInfo.primaryContactEmailAddress;
          this.editedContact.mobileNumber = this.applicationInfo.primaryContactMobileNumber;
        }
        if (contactType === "Secondary") {
          this.editedContact.contactType = "Secondary";
          this.editedContact.name = this.applicationInfo.secondaryContactFirstname;
          this.editedContact.surname = this.applicationInfo.secondaryContactLastname;
          this.editedContact.idNumber = this.applicationInfo.secondaryContactIdNumber;
          this.editedContact.emailAddress = this.applicationInfo.secondaryContactEmailAddress;
          this.editedContact.mobileNumber = this.applicationInfo.secondaryContactMobileNumber;
        }
        if (contactType === "Billing") {
          this.editedContact.contactType = "Billing";
          this.editedContact.name = this.applicationInfo.billingContactFirstname;
          this.editedContact.surname = this.applicationInfo.billingContactLastname;
          this.editedContact.idNumber = this.applicationInfo.billingContactIdNumber;
          this.editedContact.emailAddress = this.applicationInfo.billingContactEmailAddress;
          this.editedContact.mobileNumber = this.applicationInfo.billingContactMobileNumber;
        }
        this.editContactModal = true;
      }
    },
    saveEditedContact() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        if (this.editedContact.contactType === "Primary") {
          Api()
            .put("/applications/" + this.$route.params.applicationId, {
              primaryContactFirstname: this.editedContact.name,
              primaryContactLastname: this.editedContact.surname,
              primaryContactMobileNumber: this.editedContact.mobileNumber,
              primaryContactEmailAddress: this.editedContact.emailAddress,
              primaryContactIdNumber: this.editedContact.idNumber,
            })
            .then((response) => {
              this.initialize();
              this.editContactModal = false;
              this.editedContact = {};
            });
        }
        if (this.editedContact.contactType === "Secondary") {
          Api()
            .put("/applications/" + this.$route.params.applicationId, {
              secondaryContactFirstname: this.editedContact.name,
              secondaryContactLastname: this.editedContact.surname,
              secondaryContactMobileNumber: this.editedContact.mobileNumber,
              secondaryContactEmailAddress: this.editedContact.emailAddress,
              secondaryContactIdNumber: this.editedContact.idNumber,
            })
            .then((response) => {
              this.editContactModal = false;
              this.editedContact = {};
              this.initialize();
            });
        }
        if (this.editedContact.contactType === "Billing") {
          Api()
            .put("/applications/" + this.$route.params.applicationId, {
              billingContactFirstname: this.editedContact.name,
              billingContactLastname: this.editedContact.surname,
              billingContactMobileNumber: this.editedContact.mobileNumber,
              billingContactEmailAddress: this.editedContact.emailAddress,
              billingContactIdNumber: this.editedContact.idNumber,
            })
            .then((response) => {
              this.editContactModal = false;
              this.editedContact = {};
              this.initialize();
            });
        }
      }
    },
    async goToLocation() {
      let route = await this.$store.state.currentOrg.org.permissions.filter(
        function (el) {
          return el.url === "/locationNetworks/:locationNetworkId/:locationId";
        }
      );

      await this.$store.dispatch("setCurrentRoute", route[0]);
      this.$router.push({
        path:
          "/locationNetworks/" +
          this.applicationInfo.location.locationNetworkId +
          "/" +
          this.applicationInfo.locationId,
      });
    },
    addContact(contactType) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        let name = null;
        let surname = null;
        let idNumber = null;
        let mobileNumber = null;
        let emailAddress = null;
        let password = "P@ssw0rd1234";
        let permissions = "End Client";
        let isActive = true;
        if (contactType === "Primary") {
          this.creatingPrimaryContact = true;
          name = this.applicationInfo.primaryContactFirstname;
          surname = this.applicationInfo.primaryContactLastname;
          idNumber = this.applicationInfo.primaryContactIdNumber;
          emailAddress = this.applicationInfo.primaryContactEmailAddress;
          mobileNumber = this.applicationInfo.primaryContactMobileNumber;
        }
        if (contactType === "Secondary") {
          this.creatingSecondaryContact = true;
          name = this.applicationInfo.secondaryContactFirstname;
          surname = this.applicationInfo.secondaryContactLastname;
          idNumber = this.applicationInfo.secondaryContactIdNumber;
          emailAddress = this.applicationInfo.secondaryContactEmailAddress;
          mobileNumber = this.applicationInfo.secondaryContactMobileNumber;
        }
        if (contactType === "Billing") {
          this.creatingBillingContact = true;
          name = this.applicationInfo.billingContactFirstname;
          surname = this.applicationInfo.billingContactLastname;
          idNumber = this.applicationInfo.billingContactIdNumber;
          emailAddress = this.applicationInfo.billingContactEmailAddress;
          mobileNumber = this.applicationInfo.billingContactMobileNumber;
        }
        Api()
          .post("/contacts", {
            name: name,
            surname: surname,
            idNumber: idNumber,
            mobileNumber: mobileNumber,
            emailAddress: emailAddress,
            password: password,
            permissions: permissions,
            isActive: isActive,
          })
          .then((response) => {
            if (contactType === "Primary") {
              this.creatingPrimaryContact = false;
              Api()
                .put("/applications/" + this.applicationInfo.id, {
                  primaryContactId: response.data.id,
                })
                .then(
                  (this.applicationInfo.primaryContactId = response.data.id)
                );
            } else if (contactType === "Secondary") {
              this.creatingSecondaryContact = false;
              Api()
                .put("/applications/" + this.applicationInfo.id, {
                  secondaryContactId: response.data.id,
                })
                .then(
                  (this.applicationInfo.secondaryContactId = response.data.id)
                );
            } else if (contactType === "Billing") {
              this.creatingBillingContact = false;
              Api()
                .put("/applications/" + this.applicationInfo.id, {
                  billingContactId: response.data.id,
                })
                .then(
                  (this.applicationInfo.billingContactId = response.data.id)
                );
            }
          });
      }
    },
    mergePrimaryContact(item) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        confirm(
          "Are you sure you would like to update the existing contact?"
        ) &&
          Api()
            .put("/contacts/" + item.id, {
              name: this.applicationInfo.primaryContactFirstname,
              surname: this.applicationInfo.primaryContactLastname,
              idNumber: this.applicationInfo.primaryContactIdNumber,
              mobileNumber: this.applicationInfo.primaryContactMobileNumber,
              emailAddress: this.applicationInfo.primaryContactEmailAddress,
            })
            .then((response) => {
              Api()
                .put("/applications/" + this.applicationInfo.id, {
                  primaryContactId: item.id,
                })
                .then((this.applicationInfo.primaryContactId = item.id));
            });
        this.similarContactsModalPrimary = false;
      }
    },
    mergeSecondaryContact(item) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        confirm(
          "Are you sure you would like to update the existing contact?"
        ) &&
          Api()
            .put("/contacts/" + item.id, {
              name: this.applicationInfo.secondaryContactFirstname,
              surname: this.applicationInfo.secondaryContactLastname,
              idNumber: this.applicationInfo.secondaryContactIdNumber,
              mobileNumber: this.applicationInfo.secondaryContactMobileNumber,
              emailAddress: this.applicationInfo.secondaryContactEmailAddress,
            })
            .then((response) => {
              Api()
                .put("/applications/" + this.applicationInfo.id, {
                  secondaryContactId: item.id,
                })
                .then((this.applicationInfo.secondaryContactId = item.id));
            });
        this.similarContactsModalSecondary = false;
      }
    },
    mergeBillingContact(item) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        confirm(
          "Are you sure you would like to update the existing contact?"
        ) &&
          Api()
            .put("/contacts/" + item.id, {
              name: this.applicationInfo.billingContactFirstname,
              surname: this.applicationInfo.billingContactLastname,
              idNumber: this.applicationInfo.billingContactIdNumber,
              mobileNumber: this.applicationInfo.billingContactMobileNumber,
              emailAddress: this.applicationInfo.billingContactEmailAddress,
            })
            .then((response) => {
              Api()
                .put("/applications/" + this.applicationInfo.id, {
                  billingContactId: item.id,
                })
                .then((this.applicationInfo.billingContactId = item.id));
            });
        this.similarContactsModalBilling = false;
      }
    },
    async createFullInstallTicket() {
      // this.addTicketModal = true
      await Api()
        .post("/ticket", {
          applicationId: this.$route.params.applicationId,
          locationId: this.applicationInfo.locationId,
          currentStatus: "Pending",
          importance: "Average",
          description: "Full fibre & Device Installation",
          ticketCategoryItemId: 17,
          createdById: this.$store.state.user.id,
        })
        .then(() => {
          this.snackbar = true;
          this.text = "Successfully created install ticket!";
          this.fetchTickets();
        });
    },
    async createTicket(type) {
      if(this.authCreate(this.$store.state.currentRoute)){
        this.ticketOptions.currentStatus = "Pending";
      this.ticketOptions.importance = "Average";

      this.ticketOptions.ticketCategoryId = 2;
      if (type == "Passive") {
        this.ticketOptions.ticketCategoryItemId = 16;
        this.ticketOptions.description = "Passive Fibre Installation";
      } else if (type == "Active") {
        this.ticketOptions.ticketCategoryItemId = 15;
        this.ticketOptions.description = "ONU Installation";
      } else if (type == "Full") {
        this.ticketOptions.ticketCategoryItemId = 17;
        this.ticketOptions.description = "Full Fibre & ONU Installation";
      }
      this.ticketCommentLog = [];
      
      this.ticketOptions.shareWithIsp = this.applicationInfo.packagesIspId?true:false
      this.addTicketModal = true;
      }
      
    },
    async createNewTicket() {
      this.ticketOptions.applicationId = this.$route.params.applicationId;
      this.ticketOptions.locationId = this.applicationInfo.locationId;
      if(this.applicationInfo.packagesIsp){
      this.ticketOptions.customerOrganisationId = (this.ticketOptions.shareWithIsp)? this.applicationInfo.packagesIsp.customerOrganisationId:null
      }
      await Api()
        .post("/ticket", this.ticketOptions)
        .then((response) => {
          this.fetchTickets();
          if (this.ticketCommentLog.length > 0) {
            for (let i = 0; i < this.ticketCommentLog.length; i++) {
              this.ticketCommentLog[i].ticketId = response.data.id;
            }
            Api()
              .post("/ticketComment", {
                batch: this.ticketCommentLog,
              })
              .then((response) => {});
          }
          if (this.ticketOptions.assignedToId) {
            Api().post("/ticketAssignLog", {
              assignedToId: this.ticketOptions.assignedToId,
              assignedById: this.$store.state.user.id,
              ticketId: response.data.id,
            });
          }
        });
      this.addTicketModal = false;
      this.ticketOptions = {};
      this.ticketCommentLog = [];
    },
    fetchTicketComments(id) {
      Api()
        .get("/ticketComment/byTicket/" + id)
        .then((response) => {
          this.ticketCommentLog = response.data;
        });
    },
    fetchTicketAssignments(id) {
      Api()
        .get("/ticketAssignLog/byTicket/" + id)
        .then((response) => {
          this.ticketAssignedLog = response.data;
        });
    },
    
    createLocationContacts(contactId, contactTypeId) {
      Api().post("/locationContact", {
        contactId: contactId,
        locationId: this.applicationInfo.locationId,
        contactTypeId: contactTypeId,
        isActive: true,
        isDeleted: false,
      });
    },
   
    getLinkedContacts() {
      Api()
        .get("/contacts/linked", {
          params: {
            idNumber: this.applicationInfo.primaryContactIdNumber,
            emailAddress: this.applicationInfo.primaryContactEmailAddress,
            mobileNumber: this.applicationInfo.primaryContactMobileNumber,
          },
        })
        .then((response) => {
          this.linkedPrimaryContacts = response.data;
        });
      if (this.applicationInfo.secondaryContactFirstname !== null) {
        Api()
          .get("/contacts/linked", {
            params: {
              idNumber: this.applicationInfo.secondaryContactIdNumber,
              emailAddress: this.applicationInfo.secondaryContactEmailAddress,
              mobileNumber: this.applicationInfo.secondaryContactMobileNumber,
            },
          })
          .then((response) => {
            this.linkedSecondaryContacts = response.data;
          });
      }
      if (this.applicationInfo.billingContactFirstname !== null) {
        Api()
          .get("/contacts/linked", {
            params: {
              idNumber: this.applicationInfo.billingContactIdNumber,
              emailAddress: this.applicationInfo.billingContactEmailAddress,
              mobileNumber: this.applicationInfo.billingContactMobileNumber,
            },
          })
          .then((response) => {
            this.linkedBillingContacts = response.data;
          });
      }
    },
    async getApplication() {
      await Api()
        .get("/applications/supplier/" + this.$route.params.applicationId)
        .then((response) => {
          this.applicationInfo = response.data;
          this.initialAccessBuildDocument = this.applicationInfo.additionalAccessBuildDocument;
          this.initialAccessBuildFee = this.applicationInfo.additionalAccessBuildFeeExclVat;
          this.$router.push({
            query: { search: "", offset: "0", records: "10" },
          });
          if (this.applicationInfo.locationId) {
            this.locationContacts = [];
            if (typeof this.applicationInfo.location.devices !== "undefined") {
              for (
                let i = 0;
                i < this.applicationInfo.location.devices.length;
                i++
              ) {
                if (
                  this.applicationInfo.location.devices[i].deviceMakeModel
                    .deviceType.name == "GPON ONU" &&
                  this.applicationInfo.location.devices[i].isActive
                ) {
                  this.device = this.applicationInfo.location.devices[i];
                }
              }
            }

            if (
              typeof this.applicationInfo.location.locationContacts !==
                "undefined" &&
              this.applicationInfo.location.locationContacts.length > 0
            ) {
              for (
                let y = 0;
                y < this.applicationInfo.location.locationContacts.length;
                y++
              ) {
                if (
                  this.applicationInfo.location.locationContacts[y].isActive &&
                  !this.applicationInfo.location.locationContacts[y].isDeleted
                ) {
                  this.locationContacts.push(
                    this.applicationInfo.location.locationContacts[y]
                  );
                }
              }
            }
          } else {
            // this.attachLocationModal = true;
          }

          this.setActiveTabName("applicationContacts");

          this.getLinkedContacts();
          if (
            !this.applicationInfo.hasTvOverFibre &&
            this.applicationInfo.packagesIspId === null
          ) {
            (this.applicationInfo.isInstallVerified = true),
              (this.applicationInfo.isDeviceVerified = true);
          }
        });
        // if(this.applicationInfo.coordinates){
        //   this.applicationInfo.coordinates = JSON.parse(this.applicationInfo.coordinates)
        //   this.applicationInfo.coordinates = {
        //     lat: parseFloat(this.applicationInfo.coordinates.lat),
        //     lng: parseFloat(this.applicationInfo.coordinates.lng)
        //   }
        // }
      this.pages = new Array(this.locationContacts.length);
      for (let i = 0; i < this.locationContacts.length; ++i) this.pages[i] = 0;
       if(this.$store.state.currentOrg.org.id!==this.applicationInfo.supplierOrganisationId){
         this.readOnly = true
       }
    },
  },
};
</script>

<style>
.rounded-card {
  border-radius: 30px;
}
.v-stepper__header {
  box-shadow: none;
}
.v-icon.outlined {
  margin: 1px;
  border: 1px solid currentColor;
  border-radius: 20%;
  height: 30px;
  width: 30px;
  background-color: white;
  z-index: 5;
}
</style>
